import React, { useEffect, useState } from "react";
import { useRouter } from "next/router";
import PhoneInput from 'react-phone-number-input';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import WebcamCapture from "../../components/webcaptureWrappter";
import { GET_O_EVENT_DETAIL, HOME_URL, REGISTER_O_EVENT_ATTENDEE } from "../../vars";
import { UGET, UPOST } from "../../helpers";


const RegisterLayout = ({ children, title }) => {

    return (
        <div>
            <section className="userregistration">
                <div className="custom-container">
                    <div className="row userregisterlogo">
                        <div className="col-12">
                            <img src="../static/img/events/logo.png" alt="Event Logo" />
                        </div>
                    </div>
                    <div className="row">
                        <h3 className="usereventname"> {title && title}</h3>
                        <h5 className="usereventhead">Grab Your Event Memories From This Event</h5>
                        <p className="usereventsubhead">Register your selfie to get all your photos automatically, with AI and face recognition technology.</p>
                    </div>
                    {children}
                </div>

            </section>
        </div>
    )
}

const RegisterForm = (props) => {
    const { event_uuid, setRegistered } = props;
    const [isCameraOpen, setIsCameraOpen] = useState(false);
    const [selfie, setSelfie] = useState(null);
    const [isAcceptedTerms, setAcceptTerms] = useState(false);

    const [formData, setFormData] = useState({
        fullname: "",
        email: "",
        whatsappnumber: "",
        selfie: "",
    });


    function validateForm() {
        const { fullname, email, whatsappnumber } = formData;
        if (!whatsappnumber || !selfie || !isAcceptedTerms) {
            alert("Please fill the required fields");
            return false;
        }

        if (fullname){
            // validate min 5chars 
            if (fullname.length < 5) {
                alert("Please enter a valid name with min 5chars");
                return false;
            }
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (email && !emailRegex.test(email)) {
            alert("Please enter a valid email");
            return false;
        }

        const parsedNumber = parsePhoneNumberFromString(whatsappnumber);
        if (!parsedNumber || !parsedNumber.isValid()) {
            alert("Please enter a valid WhatsApp number");
            return false;
        }

        return true;
    }

    const sendFormData = async () => {
        if (!validateForm()) {
            return;
        }

        let selfieBlob;

        if (selfie instanceof Blob) {
            selfieBlob = selfie; // Already a Blob, use it directly
        } else if (typeof selfie === 'string' && selfie.startsWith('data:')) {  // Data URL
            const parts = selfie.split(',');
            const contentType = parts[0].split(':')[1].split(';')[0]; // Extract content type
            const byteCharacters = atob(parts[1]);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            selfieBlob = new Blob([byteArray], { type: contentType });

        } else if (selfie && selfie.file) { // Handle File input element directly
            selfieBlob = selfie.file;
        } else {
            console.error("Invalid selfie data. It must be a Blob, File, or a data URL.");
            return; // Stop execution if selfie is invalid
        }

        let countryCode = "";
        let nationalNumber = formData.whatsappnumber;
        const parsedNumber = parsePhoneNumberFromString(formData.whatsappnumber);
        if (parsedNumber) {
            countryCode = parsedNumber.countryCallingCode;
            nationalNumber = parsedNumber.nationalNumber;
        }

        const formDataToSend = new FormData();
        formDataToSend.append("name", formData.fullname);
        formDataToSend.append("email", formData.email);
        formDataToSend.append("phone_number", nationalNumber);
        formDataToSend.append("country_code", countryCode);
        formDataToSend.append("selfie", selfieBlob, "selfie.jpg");
        formDataToSend.append("event_uuid", event_uuid);
        //     if (blobImage) { 
        // }

        try {
            UPOST(REGISTER_O_EVENT_ATTENDEE, formDataToSend).then((res) => {
                console.log("Success:", res);
                alert("Registered Successfully");
                setRegistered(true);
            }).catch((err) => {
                console.error("Error:", err.response);
                if (err.response.data && err.response.data.error) {
                    alert(err.response.data.error);
                }
            });
        } catch (error) {
            console.error("Error:", error);
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevState) => ({ ...prevState, [name]: value }));
    };

    return (
        <>
            <div className="row mx-2 my-4 text-center" >
                <div className="col-12">
                    {(selfie) &&
                        <img className="uploadedimg" src={selfie} />
                    }
                </div>
            </div>
            {(!selfie) && <div className="row mx-2 my-4 selfie" id="selfie-text">
                {isCameraOpen ? (
                    <WebcamCapture setSelfie={setSelfie} />
                ) : (
                    <h5
                        className="selfietext"
                        onClick={() => setIsCameraOpen(true)}
                    >
                        <a href="#">Take a Selfie</a><span className="required">*</span>
                    </h5>
                )}
            </div>}

            <div className="row mx-2 my-3 d-none">
                <label htmlFor="fullname">
                    Selfie upload <span className="required">*</span>
                </label>
                <input
                    type="file"
                    id="fullname"
                    name="selfie"
                    className="input"
                    placeholder="Insert selfie"
                    // value={formData.fullname}
                    onChange={(e) => {
                        const file = e.target.files[0];
                        if (file) {
                            // setSelfie(URL.createObjectURL(file));
                            setSelfie(file);
                            // setFormData((prevState) => ({ ...prevState, selfie: file }));
                        }
                    }}
                    required
                />
            </div>

            <div className="row mx-2 my-3">
                <label htmlFor="whatsappnumber">
                    Whatsapp Number <span className="required">*</span>
                </label>
                <PhoneInput
                    id="whatsappnumber"
                    name="whatsappnumber"
                    className="input"
                    placeholder="Enter Your Whatsapp Number for photos"
                    value={formData.whatsappnumber}
                    onChange={(value) => setFormData(prev => ({ ...prev, whatsappnumber: value }))}
                    required
                />
            </div>

            <div className="row mx-2 my-3">
                <label htmlFor="email">Email</label>
                <input
                    type="email"
                    id="email"
                    name="email"
                    className="input"
                    placeholder="Enter Your Email"
                    value={formData.email}
                    onChange={handleInputChange}
                />
            </div>

            <div className="row mx-2 my-3">
                <label htmlFor="fullname">
                    Full Name
                </label>
                <input
                    type="text"
                    id="fullname"
                    name="fullname"
                    className="input"
                    placeholder="Enter Your Name"
                    value={formData.fullname}
                    onChange={handleInputChange}
                    required
                />
            </div>

            <div className="mx-2 my-3 usereventcheckbox d-flex align-center">
                <input
                    type="checkbox"
                    id="terms"
                    checked={isAcceptedTerms}
                    onChange={(e) => setAcceptTerms(e.target.checked)}
                    required
                />
                <label htmlFor="terms" className="termstext">
                    I agree to the <a href="https://www.picxy.com/terms_and_conditions" rel="nofollow"><b>Terms & Conditions</b></a>. Learn about how we use and protect your data in our <a href="https://www.picxy.com/privacy_policy" rel="nofollow" ><b>Privacy Policy</b></a>.
                </label>
            </div>

            <div className="row mx-2 my-3">
                <button className="registerbtn" onClick={sendFormData}>
                    Register For Photos
                </button>
                <p className="submittext">
                    By clicking submit, you give us permission to use AI facial recognition to securely deliver event photos directly to you.
                </p>
            </div>
        </>
    );
};

const RegisterSuccess = () => {

    const [timer, setTimer] = useState(10);

    useEffect(() => {
        const interval = setInterval(() => {
            setTimer((prevTimer) => prevTimer - 1);
        }, 1000);

        // Redirect after the timer reaches 0
        if (timer <= 5) {
            window.location.href = HOME_URL; // Redirect to the desired URL
        }

        // Cleanup interval on component unmount
        return () => clearInterval(interval);
    }, [timer]);

    return (
        <div>
            <div class="row mx-2 my-3 successfullsection">
                <div class="col-12 text-center">
                    <i class="fa fa-check checkicon"></i>
                    <br />
                    <p class="congratstext"><span class="congrats">Congratulation </span><br />
                        Successfully registered for all your Photos</p>
                </div>
            </div>
            <div class="row mx-2 my-3 successfullsection">
                <div class="col-12 text-center">
                    <p class="registertext">You will be redirected to <br />
                        Picxy.com in</p>
                    <div id="countdown"><span class="countnumber">{timer} </span></div>
                    <div class="text-center text-seconds">Seconds</div>
                </div>
            </div>
        </div>
    );
}
const Register = () => {

    const { event_uuid } = useRouter().query
    const [isRegistered, setRegistered] = useState(false);
    const [title, setTitle] = useState(null)

    useEffect(() => {
        get_event();
        // display none to .button-bar - Talk to Experts
        document.querySelector(".button-bar").style.display = "none";
    },[])

    function get_event() {
        UGET(GET_O_EVENT_DETAIL + event_uuid).then((response) => {
            console.log("get event response ", response)
            if (response.data?.success) {
                setTitle(response.data.data.title)
            }
        }).catch((error) => {
            console.log("error ", error)
        }
        )
    }
    return (
        <RegisterLayout title={title}>
            {isRegistered ||
                <RegisterForm event_uuid={event_uuid} setRegistered={setRegistered} />
            }
            {isRegistered && <RegisterSuccess />}
        </RegisterLayout>
    )
}
export default Register;
